import { render, staticRenderFns } from "./BrawlStarsAccount.vue?vue&type=template&id=7dedf6b2&lang=pug"
import script from "./BrawlStarsAccount.vue?vue&type=script&lang=js"
export * from "./BrawlStarsAccount.vue?vue&type=script&lang=js"
import style0 from "./BrawlStarsAccount.vue?vue&type=style&index=0&id=7dedf6b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports